import { render } from "./BridgingVolunteerPostViewPage.vue?vue&type=template&id=1b4b7f99"
import script from "./BridgingVolunteerPostViewPage.vue?vue&type=script&lang=js"
export * from "./BridgingVolunteerPostViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__